import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Link, useParams} from 'react-router-dom';
import {isEmpty} from 'lodash';
import {Card, Header, Form, Button, Progress} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import {validateWeekItems} from '../utils';
import AgencyWaitHappyTable from './Table';
import Loader from '../../../common/components/loader';
import FormClientWaitHappy from '../common/FormClient';
import FormVehicleWaitHappy from '../common/FormVehicle';
import './agency.scss';

const {
  navigateTo,
  getDetailWaitHappy,
  getWeekListWaitHappy,
  updateWeekListWaitHappy,
} = Actions;

const Divisor = ({text}) => {
  return (
    <p className='warranty-divisor'>{text}</p>
  );
};

const AgencyWaitHappy = () => {
  const [data, setData] = useState([]);
  const waitHappyVehicleDetail = useSelector((state) => state.waitHappyVehicleDetail);
  const weeksWaitHappy = useSelector((state) => state.weeksWaitHappy);
  const session = useSelector((state) => state.session);
  const dispatch = useDispatch();
  const params = useParams();

  useEffect(() => {
    if (!hasAccessPermission(session.permissions, resources.DealerWaitHappy, scopes.See)) {
      dispatch(navigateTo(paths.AccessDenied));
    }
    dispatch(getDetailWaitHappy(params.id));
    dispatch(getWeekListWaitHappy(params.id));
  }, [dispatch]);

  const handleChange = (value) => {
    setData(value);
  };

  const handleSubmit = () => {
    const weeksList = weeksWaitHappy.list;
    const rawDetail = data.filter((week, index) =>
      validateWeekItems(week, weeksList[index])
    );
    const username = session.user.toUpperCase();
    const detail = rawDetail.map((week) => ({...week, 'id': week.idWait, 'idweek': week.idWeek, username}));
    dispatch(updateWeekListWaitHappy({'detail': detail}));
    dispatch(navigateTo(paths.ListVehiclesWaitHappy));
  };

  if (isEmpty(waitHappyVehicleDetail.data)) {
    return <div>
      <h3>No se encontro el vehículo</h3>
      <Link to={paths.ListVehiclesWaitHappy}>Regresar</Link>
    </div>;
  }

  if (weeksWaitHappy.loading || waitHappyVehicleDetail.loading) {
    return <Loader />;
  }

  return (
    <div>
      <Card raised fluid>
        <div className='container-vehicles-happy-wait pd'>
          <Header as='h2'>Espera feliz momentos </Header>
        </div>
      </Card>
      <Card raised fluid>
        <Form onSubmit={handleSubmit} className='pd container-form-happy-wait'>
          {waitHappyVehicleDetail.data.status !== null && (
            <Progress
              color='green'
              progress='ratio'
              value={waitHappyVehicleDetail.data.status}
              total={12}
              label={`${waitHappyVehicleDetail.data.status} de ${12} momentos `}
            />
          )}
          <Divisor text='Datos del cliente' />
          <FormClientWaitHappy detail={waitHappyVehicleDetail.data} />
          <Divisor text='Datos del vehículo' />
          <FormVehicleWaitHappy
            detail={waitHappyVehicleDetail.data}
            agency={true}
          />
          <Divisor text='Selección de estado (en semanas)' />
          <AgencyWaitHappyTable
            handleChange={handleChange}
            dataTable={weeksWaitHappy.list}
          />

          <div className='mt mb container-button-happy-wait'>
            <Button
              disabled={!weeksWaitHappy.list.length}
              color='green'
              type='submit'
            >
              Actualizar
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default AgencyWaitHappy;
